export const CHANGE_CONTENT_LOADING = 'HOME/CHANGE_CONTENT_LOADING';
export const CHANGE_CONTENT_PADDINGBOTTOM = 'HOME/CHANGE_CONTENT_PADDINGBOTTOM';
